<template>
  <div class="container">
    <div class="content">
      <p class="heading horizontal-padding">
        <span>香の川製麺アプリのご利用<br>
        ありがとうございました</span>
      </p>
      <img :src="require('@/assets/img/thanks.svg')" class="horizontal-padding" style="width: 70%" />
      <p class="heading horizontal-padding">
        あなたのアカウントは<br>
        削除されました
      </p>
      <p class="horizontal-padding" style="margin-top: 30px">
      <span>
        <span style="color: #E03535">・このアプリは削除してください。</span><br>
        ・削除したアカウントの履歴の復帰はできません。<br>

        ・アプリIDに連携していたAppleIDアカウントは削除と同時に解除されます。削除後、連携していたAppleIDアカウントでのログインはできません。<br>
        ・ジョイフル商品レシート・領収書応募サービスにアプリIDで連携していた場合、ジョイフル商品レシート・領収書応募サービスでの履歴及び取得した特典などにアクセスできなくなります。<br>

        ・削除後にお問い合わせを頂いても、調査はできません。あらかじめご了承ください。<br>
      </span>
      </p>
    </div>
  </div>
 </template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'
export default {
  name: 'AccountDelete',
  created() {
    document.title = 'アプリアカウント削除'
    this.trackEvent(FactoryTrack.createAccountDelete())
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent'])
   }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  .content {
    padding: 30px 0;

    p {
      text-align: left;
      color: #333333;
      font-size: 14px;
      margin-bottom: 30px;
    }

    .heading {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }

    .horizontal-padding {
      padding: 0 30px;
    }
  }
  .content .l_button__external {
      width: 250px;
      margin: 20px auto 0;
   }
}
</style>
